import CircularProgress from '@jimmyboys/liita-ui/dist/components/CircularProgress'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import ExpandableWidget from 'components/ExpandableWidget/ExpandableWidget'
import { MedicalSpecialtyDisability } from 'models'

import styles from './widgets.module.sass'

const renderDisabilityHistory = (history, i18n) => {
	return history.map((disability, index) => {
		const disabilities = disability.history || [] //.filter(({rate}) => rate > 0)
		const hasDisabilities = disabilities.length > 0
		return [
			hasDisabilities ? (
				<h5 key={index} className={styles['group-title']}>
					{i18n.translate(disability.name)}
				</h5>
			) : null,
			disabilities.reverse().map((historyEntry, index) => (
				<HStack
					key={`inner_${index}`}
					className={styles['entry']}
					columns={['20px', 3]}
					flex={[
						[0, 0],
						[1, 1],
					]}
					gap='small'
					align='center'
				>
					<div className={styles['circular-progress-container']}>
						<CircularProgress
							size={20}
							progress={historyEntry.rate}
						/>
						<small
							className={styles['circular-progress-percentage']}
						>
							{historyEntry.rate}
						</small>
						<small>%</small>
					</div>
					<div>
						<h5>{historyEntry.type?.name}</h5>
						<small>
							{historyEntry.startDate?.shortDateFormat} -{' '}
							{historyEntry.endDate?.shortDateFormat || ''}
						</small>
					</div>
				</HStack>
			)),
		]
	})
}

const DisabilitiesSummaryWidget = (props) => {
	const { data } = props
	const { disabilityHistory } = data
	const { i18n } = useGlobal()

	const { grouped, perDay, partialDisabilityDays, totalDisabilityDays } =
		MedicalSpecialtyDisability.computeHistoryStats(disabilityHistory || [])

	return (
		<ExpandableWidget
			className={styles['aside-widget']}
			titleAppearance='aside-widget'
			arrowPosition='right'
			heading='h5'
			icon='disabled'
			title={i18n`Summary of disabilities`}
			expanded={!!perDay.length}
			expandable={!!perDay.length}
			borderRadius
			margins={['small', '', '']}
			paddings={['xsmall', 'xsmall', 'xsmall']}
		>
			<HStack columns={[1, 1]} gap='xsmall'>
				<div className={styles['text-align-center']}>
					<h5
						className={styles['group-title']}
					>{i18n`Temporary Partial Disability`}</h5>
					<small>
						<strong>{partialDisabilityDays}</strong>
					</small>
				</div>
				<div className={styles['text-align-center']}>
					<h5
						className={styles['group-title']}
					>{i18n`Temporary Total Disability`}</h5>
					<small>
						<strong>{totalDisabilityDays}</strong>
					</small>
				</div>
			</HStack>
			{renderDisabilityHistory(grouped || [], i18n)}
		</ExpandableWidget>
	)
}

export default DisabilitiesSummaryWidget
